import { ApplicationRangeDto } from "app/shared/models/application-range.model";
import { AutomaticDiscountOperatorEnum } from "../../back-office/shared/enum/automatic-discount-operator.enum.model";
import { AutomaticDiscountPropertyEnum } from "../../back-office/shared/enum/automatic-discount-property.enum.model";
import { DiscountApplicationTypeEnum } from "../enums/discount-application-type.enum.model";
import { IncludeModeEnum } from "../../back-office/shared/enum/include-mode-type.enum";
import { ValidityScopeTypeEnum } from "../../back-office/shared/enum/validity-scope-type.enum.model";
import { ApplicationRangeVm } from "../../back-office/shared/models/back-office-admin-common/application-range.models";
import { Showcase } from "./showcases.model";
import { PromotionVisibilityTypeEnum } from "app/back-office/shared/enum/promotion-visibility-type.enum.model";

export class AutomaticDiscountDto {
  id: number;
  name: string;
  validityDateFrom: string;
  validityDateTo: string;
  validityScope: ValidityScopeTypeEnum;
  applicationType: DiscountApplicationTypeEnum;
  type: IncludeModeEnum;
  storeId: number;
  lastModificationTime: string;
  creationTime: string;
  creatorId: number;
  lastModifierId: number;
  matchByEntireOrder: boolean;
  showcaseId: number;
  showcase: Showcase
  isFeatured?: boolean;
  constructor(init?: Partial<AutomaticDiscountGetDto>) {
    Object.assign(this, init);
    if (!this.applicationType && this.applicationType !== 0) this.applicationType = DiscountApplicationTypeEnum.ByQuantity;
    if (!this.type && this.type !== 0) this.type = IncludeModeEnum.static;
  }
}

export class AutomaticDiscountGetDto extends AutomaticDiscountDto {
  applicationsRange: ApplicationRangeDto[];
  constructor(init?: AutomaticDiscountGetDto) {
    super();
    Object.assign(this, init);
    if (!this.applicationsRange) this.applicationsRange = [new ApplicationRangeDto()];
    if (!this.applicationType && this.applicationType !== 0) this.applicationType = DiscountApplicationTypeEnum.ByQuantity;
    if (!this.type && this.type !== 0) this.type = IncludeModeEnum.static;
    if (!this.name) this.name = null;
    if (!this.validityDateFrom) this.validityDateFrom = null;
    if (!this.validityDateTo) this.validityDateTo = null;
    if (!this.validityScope && this.validityScope !== 0) this.validityScope = null;
  }
}

export class AutomaticDiscountVM extends AutomaticDiscountDto {
  applicationsRange: ApplicationRangeVm[];
  constructor(init?: Partial<AutomaticDiscountVM>) {
    super();
    Object.assign(this, init);
    if (!this.applicationsRange) this.applicationsRange = [new ApplicationRangeVm()];
    if (!this.applicationType && this.applicationType !== 0) this.applicationType = DiscountApplicationTypeEnum.ByQuantity;
    if (!this.type && this.type !== 0) this.type = IncludeModeEnum.static;
    if (!this.name) this.name = null;
    if (!this.validityDateFrom) this.validityDateFrom = null;
    if (!this.validityDateTo) this.validityDateTo = null;
    if (!this.validityScope && this.validityScope !== 0) this.validityScope = null;
    if (this.matchByEntireOrder === null || this.matchByEntireOrder === undefined) this.matchByEntireOrder = false;

  }
}

export class AutomaticDiscountRuleDto {
  id?: number;
  value: string;
  operator: AutomaticDiscountOperatorEnum;
  automaticDiscountProperty: AutomaticDiscountPropertyEnum;
  constructor(init?: Partial<AutomaticDiscountRuleDto>) {
    Object.assign(this, init);
    if (!this.id && this.id !== 0) this.id = null;
  }
}

export class AutomaticDiscountMultiSelectDTO extends AutomaticDiscountGetDto {
  checked: boolean;
  constructor(init?: AutomaticDiscountMultiSelectDTO) {
    super();
    Object.assign(this, init);
  }
}

export class AutomaticDiscountInputModel {
  channelId?: number;
  productId?: number;
  searchString?: string;
  storeId: number;
  variantId?: number;
  validNow?: boolean;
  visibilityType: PromotionVisibilityTypeEnum;
  showcaseId?: number;
  includeShowcase?: boolean;
  maxResultCount: number;
  skipCount: number;
  sorting?: string;
  onlyWithAssociatedVariants?: boolean;
  constructor(init?: Partial<AutomaticDiscountInputModel>) {
    Object.assign(this, init);
  }
}